
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component
export default class customRadio extends Vue {
  @Prop({ default: false }) value!: boolean //
  @Prop({ default: false }) checkAll!: boolean // 全选状态
  @Prop({ default: false }) indeterminate!: boolean // 不确定状态
  checked = false

  @Watch('value')
  onValueChange () {
    this.checked = this.value
  }

  @Watch('checkAll')
  onCheckAllChange () {
    this.checked = this.checkAll
    this.$emit('change', this.checked)
  }

  @Watch('indeterminate')
  onIndeterminateChange () {
    // if (this.indeterminate) this.checked = false
  }

  created () {
    this.checked = this.checkAll
  }

  get imgUrl () {
    if (this.indeterminate) return require('@/assets/images/newUI_8442/radio-indeterminate.png')
    if (this.checked) return require('@/assets/images/newUI_8442/radio-check.png')
    return require('@/assets/images/newUI_8442/radio-uncheck.png')
  }

  checkFn () {
    this.checked = !this.checked
    this.$emit('change', this.checked)
  }

}
